module.exports = __webpack_public_path__ + "static/media/bestof_5.e5c94910.jpg";